export default __webpack_public_path__ + "static/media/CarouselImg1.d82b5bae.png";